import { Routes } from '@angular/router';

import { MpsTranslateTitleResolver } from '../mps/resolvers/mps-translate-title.resolver';
import { applicationRouteNames } from './application-route-names';
import { profileCompleteGuard } from './profile/profile-complete.guard';
import { reportDataFilledGuard, reportTypeChosenGuard } from './report/report.guards';

/**
 * Routes du front public OSER (aucune authentification).
 * Parcours : profil → report-type → report-detail → report-location → merci.
 * (rules/stopcard ajoutés en spec 105.)
 */
const oserRoutes: Routes = [
  {
    path: applicationRouteNames.profile,
    loadComponent: () => import('./profile/profile.component').then((m) => m.ProfileComponent),
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.profile.title' },
  },
  {
    path: applicationRouteNames.reportType,
    loadComponent: () => import('./report/report-type/report-type.component').then((m) => m.ReportTypeComponent),
    canActivate: [profileCompleteGuard],
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.report.type.title' },
  },
  {
    path: applicationRouteNames.reportDetail,
    loadComponent: () => import('./report/report-detail/report-detail.component').then((m) => m.ReportDetailComponent),
    canActivate: [profileCompleteGuard, reportTypeChosenGuard],
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.report.detail.title' },
  },
  {
    path: applicationRouteNames.reportLocation,
    loadComponent: () =>
      import('./report/report-location/report-location.component').then((m) => m.ReportLocationComponent),
    canActivate: [profileCompleteGuard, reportDataFilledGuard],
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.report.location.title' },
  },
  {
    path: applicationRouteNames.reportSent,
    loadComponent: () => import('./report/report-sent/report-sent.component').then((m) => m.ReportSentComponent),
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.report.sent.title' },
  },
  {
    path: applicationRouteNames.rules,
    loadComponent: () => import('./rules/rules.component').then((m) => m.RulesComponent),
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.rules.title' },
  },
  {
    path: applicationRouteNames.stopcard,
    loadComponent: () => import('./stopcard/stopcard.component').then((m) => m.StopcardComponent),
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.stopcard.title' },
  },
  // Redirection par défaut vers l'écran de saisie (équivalent de l'ancien otherwise('/app/report-type')).
  { path: '', redirectTo: applicationRouteNames.reportType, pathMatch: 'full' },
];

// Tous les écrans partagent le même cadre (barre retour / type choisi / profil).
export const applicationRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./report/oser-layout/oser-layout.component').then((m) => m.OserLayoutComponent),
    children: oserRoutes,
  },
];
